import ClassRegistry from "./ClassRegistry";
/**
 * Created by jeffb on 4/6/2017.
 */

let shortid = require('shortid');


export default class FBSyncBase{
	id:string = FBSyncBase.genId();
	type:string;

	static genId(){
		return "__-" + shortid.generate();
	}

	static isId(obj:any){
		if(typeof obj == "string"){

			if(obj.length > 3 && obj[0] == "_" && obj[1] == "_"&& obj[2] == "-"){
				if(shortid.isValid(obj.substring(2)) && obj.length <= 16){
					return true;
				}
			}
		}

		return false;
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/framework/FBSyncBase.ts